<template>
  <div v-click-away="collapseUnlessMobile">
    <h2 class="py-3 border-b border-black md:border-none md:py-0 md:relative">
      <button
        class="w-full text-left text-base lg:text-lg uppercase tracking-wider font-futura-book"
        @click="expand"
      >
        {{ filter.label }}
        {{ expanded ? '–' : '+' }}
      </button>
    </h2>
    <expandable :expanded="expanded">
      <ul
        class="md:absolute md:p-4 md:z-10"
        :style="`background-color: ${$store.state.config.backgroundColor};`"
      >
        <li
          v-for="tagId in filter.tagIds"
          :key="tagId"
          class="my-3"
        >
          <collection-filter-item
            :tag-id="tagId"
            @tagselected="collapseUnlessMobile"
          />
        </li>
      </ul>
    </expandable>
  </div>
</template>

<script>
export default {
  props: {
    filter: { type: Object, required: true },
    mobile: { type: Boolean, default: true },
  },
  emits: ['filter-expanded'],
  data: function () {
    return {
      expanded: false,
    }
  },
  methods: {
    expand() {
      this.expanded = !this.expanded
      this.$emit('filter-expanded', this)
    },
    collapseUnlessMobile() {
      if (!this.mobile) {
        this.collapse()
      }
    },
    collapse() {
      this.expanded = false
    },
  },
}
</script>
